import * as React from "react";

const MenuCard: React.FC = () => {
  return <></>;
};

export default MenuCard;
